module.exports = __webpack_public_path__ + "img/icon_home_white.bd67df25.svg";